<template>
  <div
    :style="{
      backgroundColor:
        $utils.extractValue(backgroundColor, 'transparent', $route) == ''
          ? 'transparent'
          : $utils.extractValue(backgroundColor, 'transparent', $route)
    }"
    class="w-full bg-white dark:bg-dark-box-background">
    <Logo v-if="$utils.extractUrl(url, $route) == 'N/A'" class="w-96 h-96" />
    <iframe
      v-else-if="$utils.extractUrl(url, $route)?.includes('youtube') || url?.includes('youtu.be')"
      class="w-full h-full"
      :src="new_url"
      title="Shawn Mendes, Camila Cabello - Señorita (Lyrics)"
      frameborder="0"
      credentialless="true"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen />
    <iframe
      v-else-if="$utils.extractUrl(url, $route)?.includes('vimeo')"
      class="w-full h-full"
      :src="new_url"
      credentialless="true"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      frameborder="0"
      allowfullscreen />
    <video v-else id="video" width="800" controls>
      <source id="source" :src="$utils.extractUrl(url, $route)" type="video/mp4">
      {{ $t("Your browser does not support HTML video.") }}
    </video>
    <div
      v-if="$route.name == 'CompanyProfile' || $route.name == 'ObjectProfile'"
      class="absolute bottom-1 right-2 text-xs text-common-grey cursor-pointer z-50 has-tooltip">
      <Info class="text-common-grey w-4 h-4" />
      <span
        class="tooltip -mt-10 text-xs -ml-28 whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
        {{ $t("showing on") }} {{ typeof url == "object" ? $t("this page") : $t("all pages") }}</span>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/shared/Logo.vue"
import { Info } from "lucide-vue-next"

export default {
  components: { Logo, Info },

  inject: ["canUserEditLayout"],
  props: {
    url: {
      type: String,
      default: "N/A"
    },
    backgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      new_url: ""
    }
  },
  watch: {
    url() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.url && (this.url.includes("youtube") || this.url.includes("youtu.be"))) {
        this.new_url = `https://www.youtube.com/embed/${this.youtubeParser(this.url)}`
      } else if (this.url && this.url.includes("vimeo")) {
        this.new_url = `https://player.vimeo.com/video/${this.vimeoParser(this.url)}`
      } else {
        this.new_url = this.url
      }
      if (document.getElementById("video")) {
        let video = document.getElementById("video")
        let source = document.getElementById("source")
        source.setAttribute("src", this.new_url)
        video.load()
      }
    },
    youtubeParser(url) {
      let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
      let match = url.match(regExp)
      return match && match[7].length == 11 ? match[7] : false
    },
    vimeoParser(url) {
      let vimeoLink = new URL(url)
      //Remove leading /
      let videoId = vimeoLink.pathname.substring(1)
      return videoId
    }
  }
}
</script>
